import { OrderStatesEnum } from '../constants/order'
import { StationTypesEnum } from '../constants/stations'

export const getUpdateStateButtonText = (
    stationId: string,
    stationType: StationTypesEnum,
    orderKey: string,
    orderKitchenState: OrderStatesEnum,
    orderState: OrderStatesEnum,
    isAddressRequired: boolean
) => {
    if (orderKitchenState === OrderStatesEnum.NEW) {
        return 'Hodit do přípravy'
    }

    if (orderState === OrderStatesEnum.COOKED) {
        return 'Objednávka je zkompletována'
    }

    if (orderState !== OrderStatesEnum.ASSEMBLED) return ''

    if (isAddressRequired) {
        return 'Objednávka byla předána kurýrovi'
    }

    if (stationType === StationTypesEnum.PICKER_STATION) {
        return 'Objednávka byla vydána'
    }

    return ''
}
